import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";

import { DashboardHeader, Footer,  SuperAdminDashboardSidebar } from "@/components";
import { Toaster } from "sonner";
import { Outlet } from "react-router-dom";
import { useAppDispatch } from "@/store/hooks";


import ls from "@/utils/SecureLS";
import { LoaderCircle } from "lucide-react";
import { initializeAuthFromLocalStorage } from "@/utils/helper/initializeuserInfoFromLS";
import { useEffect } from "react";


const SuperAdminDashboard = () => {
  const dispatch = useAppDispatch();
  const userLs = ls.get("user") || "";

  const user = JSON.parse(userLs);
  const userId = user?.user_id || "";


  




  useEffect(() => {
    initializeAuthFromLocalStorage(dispatch);

    // eslint-disable-next-line
  }, []);



  return (
   
   
    <SidebarProvider className="">
      <SuperAdminDashboardSidebar variant="inset" className="" />
      <SidebarInset className=" flex flex-1 flex-col bg-white border border-gray-200">
        <DashboardHeader />
        <div className="flex flex-1 flex-col">
          <div className="@container/main flex flex-1 flex-col gap-2 min-h-full">
            <Toaster />
            {false ? (
              <div className="flex items-center justify-center flex-1 min-h-[400px]">
                <div className="flex flex-col items-center gap-4">
                  <div className="flex items-center">
                    <LoaderCircle className="w-6 h-6 animate-spin mr-4" />
                    <span>Fetching your Dashboard data. This won't take long!</span>
                  </div>
                  {/* Optional: Add a timeout message */}
                  <div className="text-sm text-gray-500 text-center max-w-md">
                    If this takes too long, try refreshing the page
                  </div>
                </div>
              </div>
            ) : (
              <>

              <Outlet />
              <Footer user={user}/>
              </>
            )}
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
    
  );
};


export default SuperAdminDashboard;
